module.exports = __webpack_public_path__ + "img/nine.be5030ca.webp";